import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import Attention from "../ReusableComponents/Attention";
import { Form, FormControl as Input, InputGroup } from "react-bootstrap";
import DefaultButton from "../ReusableComponents/DefaultButton";
import { RiCloseFill } from "react-icons/ri";
import { MdFileDownload, MdUploadFile } from "react-icons/md";
import { URL } from "../../variables";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../actions/AppActions";
import { CircularProgress } from "@material-ui/core";
import Request from "../../Request";
import { Close } from "@material-ui/icons";
import StatusBadge from "../ReusableComponents/StatusBadge";
import TableEmptyState from '../ReusableComponents/TableEmptyState';

const ModalQuestoesCsv = (props) => {
  const { t } = usePreferences();
  const token = useSelector((store) => store.AppReducer.token);
  const { categoria_name, showModal, setShowModal, categoria_id, onFinish } = props;
  const [questoes_csv, setquestoesCsv] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading_jobs, setLoadingJobs] = useState(true);

  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });

  const [csvFile, setCsvFile] = useState(null);
  const [csvValue, setCsvValue] = useState('');
  const [keyword, setKeyWord] = useState('');
  const [palavras_chaves, setParavrasChaves] = useState([]);



  const [msgErro, setMessageErro] = useState('');
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const getCsvJobStatus = (status) => {
    const normalized = String(status || '').trim().toLowerCase();
    if (normalized.includes('erro')) return { label: status || '-', tone: 'danger' };
    if (normalized.includes('finalizado')) return { label: status || '-', tone: 'success' };
    return { label: status || '-', tone: 'warning' };
  };

  const downloadModel = (fileName) => {
    const link = document.createElement('a');
    link.href = `/${fileName}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {

    if (showModal == true) {
      setLoadingJobs(true);
      setJobs([]);
      GetJobsCsvs();
    }
  }, [showModal]);

  const GetJobsCsvs = async (page = 1, search = '') => {

    let response = await Request.Get(`faculdade/get_csv_jobs_questoes/${categoria_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }


    if (response.pagination.current_page == page) {

      setJobs(response.questoes);

      setPagination(response.pagination);
      setLoadingJobs(false);


    }
  };


  const addUsers = (questoes_csv) => {
    setLoading(true);
    setMessageErro('');

    let form = new FormData();
    form.append('categoria_id', categoria_id);
    form.append('questoes', csvFile);
    palavras_chaves.map((item, id) => {
      form.append('palavras_chaves[]', item);
    });

    fetch(`${URL}api/faculdade/save_questoes_csv`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: form
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');

          dispatch(logout());
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n'; else

              erro += errors[i];
          }
          console.log(erro);
          setMessageErro(erro);
          setLoading(false);



        } else {
          setLoading(false);
          // setShowModal(false);
          setquestoesCsv([]);
          setCsvFile(null);
          GetJobsCsvs();

          // if (resp.processo != null) {


        }




      } catch (err) {
        setLoading(false);

        setMessageErro('Erro ao pegar resposta no servidor');

        console.log(err);


      }

    }).
      catch((err) => {
        setLoading(false);
        setMessageErro('Erro ao pegar resposta no servidor. Você está conectado a internet?');

        console.log(err);
      });
  };

  return (
    <Modal
      show={showModal == true}
      dialogClassName="modal-90w modal-width"
      onHide={() => {
        setShowModal(false);
        setquestoesCsv([]);
        setCsvFile(null);
        onFinish();

      }}>

      <Modal.Header closeButton closeLabel=''><Modal.Title>{t("ui_adicionar_questoes_na_disciplina_03c19af6")} {categoria_name}<br /></Modal.Title></Modal.Header>
      <Modal.Body>
        {msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
          <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setMessageErro('')}></button>


            <p style={{ marginBottom: 0, whiteSpace: 'pre' }}>{msgErro}</p>

          </div>
          <br />

        </div>}

        <div className="table-modern-card w-100">
          <div className="table-modern-scroll mb-0">
            <table id="tech-companies-1" className="table table-striped">
              <thead>
                <tr>

                  <th>{t("label_module_status")}</th>
                  <th>{t("legacy_erro")}</th>
                  <th>{t("legacy_progresso")}</th>
                  <th>{t("legacy_total")}</th>
                </tr>
              </thead>
              <tbody>
                {loading_jobs == false && jobs.map((item, id) =>

                  <tr key={id}>
                    <td><StatusBadge {...getCsvJobStatus(item.status)} /></td>
                    <td>{item.error_friendly ?? '-'}</td>
                    <td>{item.progresso}</td>
                    <td>{item.total_progresso}</td>
                  </tr>
                )}

              </tbody>
            </table>
            {loading_jobs == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center table-state-spacing">
                <CircularProgress />
              </div></div>

            }
          </div>
        </div>
        {loading_jobs == false && jobs.length == 0 && <div className="row ">
          <div className="col-12 table-state-spacing">
            <TableEmptyState title={t("legacy_nenhuma_execucao_encontrada")} icon="📋" />

          </div>
        </div>}

        {/* <InputGroup>

          <div className="flex fdcolumn flex1 margin-bottom">
            <Form.Label>{t("ui_palavras_chaves_palavras_que_serao_aplicadas_para__c51efe30")}</Form.Label>
            <div>
              <Input
                placeholder={t("legacy_palavra_chave")}
                value={keyword}
                onChange={(e) => setKeyWord(e.target.value)} />


              {<div className='row' style={{ marginLeft: 0, marginRight: 0 }}>
                {palavras_chaves.map((item, id) =>
                  <div key={id} className="question-keyword-chip" style={{ backgroundColor: '#f2f2f2', borderRadius: 10, padding: 5, width: 'auto', marginTop: 5, display: 'flex', marginRight: 5 }}>
                    <p style={{ marginBottom: 0, textAlign: 'center' }}>{item}</p>
                    <Close onClick={() => {
                      let palavras_chaves_ = palavras_chaves.filter((item2, id2) => id2 != id);
                      setParavrasChaves(palavras_chaves_);

                    }} style={{ cursor: 'pointer', width: '0.9rem', marginLeft: 3 }} />
                  </div>
                )}
              </div>}

              <div className="import-keyword-action">
                <DefaultButton
                  bg="info"
                  onClick={(e) => {
                    if (keyword.trim().length == 0) {
                      return;
                    }
                    let palavras_chaves_ = [...palavras_chaves];
                    palavras_chaves_.push(keyword);
                    setParavrasChaves(palavras_chaves_);
                    setKeyWord('');
                  }}
                  text={t("action_include_keyword")} />
              </div>

            </div>


          </div>
        </InputGroup> */}
        <InputGroup>

          <div className="flex fdcolumn flex1 margin-bottom" style={{marginTop:'1rem'}}>
            <Form.Label>{t("label_docx_file")} <Attention /> </Form.Label>
            <div className="modern-file-upload">
              <input
                id="questoes-docx-file"
                type="file"
                accept=".docx"
                value={csvValue}
                className="modern-file-upload-input"
                onChange={(e) => {

                  console.log(e.target.files[0]);
                  setCsvFile(e.target.files[0]);
                  setCsvValue('');
                  setMessageErro('');
                }} />
              <label className="modern-file-upload-trigger" htmlFor="questoes-docx-file">
                <MdUploadFile size={20} />
                <span>Selecionar arquivo DOCX</span>
              </label>
              {csvFile == null && <span className="modern-file-upload-empty">{t("ui_arquivo_docx_contendo_as_questoes_f5bf5ebe")}</span>}
            </div>

            {csvFile != null && <div className="selected-file-chip">
              <p><b>{t("label_selected_file")} </b>{csvFile.name}</p>
              <Close onClick={() => {

                setCsvFile(null);

              }} style={{ cursor: 'pointer', width: '0.9rem', marginLeft: 3 }} />
            </div>}

          </div>




        </InputGroup>
        <div className="import-instructions">
          <div>
            <b>{t("ui_padrao_3386172b")}</b>
            <p>Use um dos modelos novos abaixo conforme o tipo de questão que será importado.</p>
          </div>
          <div className="import-instructions-grid">
            <div className="import-instructions-card">
              <strong>Questões objetivas e conjunto</strong>
              <ul>
                <li>Use "Questão N)" no início de cada questão.</li>
                <li>Nas questões objetivas, use alternativas a), b), c), d) e e) em sequência.</li>
                <li>Marque a alternativa correta com marca-texto ou cor de fundo diferente de branco.</li>
                <li>Palavras-chave, Dificuldade e Escolaridade são opcionais e devem ficar entre o enunciado e as alternativas.</li>
                <li>Para conjunto, informe o intervalo no cabeçalho: "Texto-base para as questões X a Y:".</li>
              </ul>
            </div>
            <div className="import-instructions-card">
              <strong>Questões dissertativas</strong>
              <ul>
                <li>Use "Questão N)" no início de cada questão.</li>
                <li>Não inclua alternativas; o importador identifica o tipo pela ausência de a), b), c), etc.</li>
                <li>Palavras-chave, Dificuldade e Escolaridade são opcionais e devem aparecer após o enunciado.</li>
                <li>Quando os metadados não forem informados, o sistema utilizará "Não Especificado".</li>
              </ul>
            </div>
          </div>
          <div className="import-model-actions">
            <DefaultButton
              bg="secondary"
              icon={<MdFileDownload style={{ marginRight: 8 }} />}
              text="Baixar modelo - objetivas e conjunto"
              onClick={() => downloadModel('Modelo_Questoes_Objetivas_e_Conjunto.docx')} />
            <DefaultButton
              bg="secondary"
              icon={<MdFileDownload style={{ marginRight: 8 }} />}
              text="Baixar modelo - dissertativas"
              onClick={() => downloadModel('Modelo_Questoes_Dissertativas.docx')} />
          </div>
        </div>

        {loading == false && <div className="w100 inline-flex jcsb margin-top-1">
          <DefaultButton
            bg="secondary"
            text={t("action_close")}
            icon={<RiCloseFill />}
            onClick={() => {
              setShowModal(false);
              setquestoesCsv([]);
              setCsvFile(null);
              onFinish();

            }} />
          <DefaultButton
            type="button"
            disabled={csvFile == null}

            onClick={() => {
              addUsers(questoes_csv);
            }}
            bg={csvFile != null ? "confirm" : "secondary"}
            text={t("action_add")} />

        </div>}

        {loading == true && <div className="w100 inline-flex jcsb margin-top-1 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </div>}

      </Modal.Body>
    </Modal>);


};

export default ModalQuestoesCsv;
